import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { IIncomeRatioRange } from "@rentiohq/shared-frontend/dist/utils/rentmatch.utils";

export interface IExtraData {
  property: IProperty;
  hasRentMatchForBroker?: boolean;
  /** Broker's listing URL template (e.g. https://immo.be/te-huur/[ID]) */
  listingUrlTemplate?: string | null;
  /** Broker's for rent page fallback URL */
  websiteUrl?: string | null;
  /** Amenity: number of bathrooms (not on IProperty directly) */
  roomCountBathroom?: number | null;
  /** Amenity: number of garages (not on IProperty directly) */
  roomCountGarage?: number | null;
  /** Amenity: habitable surface area m² (not on IProperty directly) */
  livingSurfaceArea?: number | null;
  /** Amenity: the broker's own description of the property */
  descriptionLong?: string | null;
  /** Amenity: the link to a virtual visit, which Rentmatch shows before the
   * photos. The same amenity the property's Extra tab writes. */
  virtualTourUrl?: string | null;
  /** Amenity: the income at which this property reaches a perfect score, as
   * the broker set it. Absent means the office table or the built-in scale
   * decides, which is every property today. */
  rentmatchPerfectIncome?: number | null;
  /** The office's income table, already parsed, so the field can show what
   * this property asks today with nothing set. */
  rentmatchIncomeRanges?: IIncomeRatioRange[];
  /** Amenity: the largest household, in people, that still reaches a full
   * household score here. Absent leaves the room rule in charge. */
  rentmatchMaxHousehold?: number | null;
  /** The property the photo gallery belongs to. Absent on a property that has
   * no id yet, and then the gallery is left out rather than drawn empty. */
  propertyId?: number;
  /** Called after a photo is added or removed, so the screen behind the modal
   * catches up. The gallery stores each photo itself. */
  onPhotosSaved?: () => void;
}

export enum EField {
  Header = "_header",
  PublishHeader = "_publishHeader",
  RentMatchIntro = "_rentMatchIntro",
  BasicsHeader = "_basicsHeader",
  Price = "price",
  Costs = "costs",
  IsRentMatchPublished = "isRentMatchPublished",
  RoomCountBedroom = "roomCountBedroom",
  AvailableAtDate = "availableAtDate",
  ExternalListingUrl = "externalListingUrl",
  ExtraDetailsHeader = "_extraDetailsHeader",
  RoomCountBathroom = "roomCountBathroom",
  RoomCountGarage = "roomCountGarage",
  LivingSurfaceArea = "livingSurfaceArea",
  EpcLabel = "epcLabel",
  BuildingTerraceSurfaceArea = "buildingTerraceSurfaceArea",
  BuildingGardenSurfaceArea = "buildingGardenSurfaceArea",
  DescriptionLong = "descriptionLong",
  RentmatchScore = "rentmatchScore",
  MediaHeader = "_mediaHeader",
  Photos = "_photos",
  VirtualTourUrl = "virtualTourUrl",
}
